import './App.css';
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import { TacticP1Leanpay } from './pages/TacticP1-Leanpay';
import { TacticP2AMastercard } from './pages/TacticP2A-Mastercard';
import { TacticP2BAddiko } from './pages/TacticP2B-Addiko';
import { Interests } from './pages/Interests';
import { ThankYouPomlad2025 } from './pages/ThankYou-Pomlad2025';
import { ThankYouPoletje2025 } from './pages/ThankYou-Poletje2025';
import { ThankYouPoletniNakupi2025 } from './pages/ThankYou-PoletniNakupi2025';
import { UnfinishedLoanEstimate } from './pages/UnfinishedLoanEstimate';
import { LoanInterest } from './pages/LoanInterest';
import { CreditLimitMastercard } from './pages/CreditLimitMastercard';
import { LoanExpiring } from './pages/LoanExpiring';
import { HolidayLoan } from './pages/HolidayLoan';
import { MergeObligation } from './pages/MergeObligation';
import { HomeRenovationLoan } from './pages/HomeRenovationLoan';
import { CarLoan } from './pages/CarLoan';
import { TechLoan } from './pages/TechLoan';
import { HealthLoan } from './pages/HealthLoan';
import { WishFor2026 } from './pages/WishFor2026';


import { WithQueryParam } from './components/WithQueryParam'; 
import { ScarabLoader } from './components/ScarabLoader';

const ExternalRedirect = ({ to }) => {
  window.location.href = to;
  return null; 
};

function App() {
  return (
    <Router>
      <ScarabLoader siteId={process.env.REACT_APP_SCARAB_SITE_ID} />
      <Routes>

        {/* Tactics */}
        <Route
          path="/leanpay-stranke"
          element={
            <WithQueryParam>
              {({ hibisId }) => <TacticP1Leanpay hibisId={hibisId} />}
            </WithQueryParam>
          }
        />
        <Route
          path="/mastercard-obrocna"
          element={
            <WithQueryParam>
              {({ hibisId }) => <TacticP2AMastercard hibisId={hibisId} />}
            </WithQueryParam>
          }
        />
        <Route
          path="/addiko-kredit"
          element={
            <WithQueryParam>
              {({ hibisId }) => <TacticP2BAddiko hibisId={hibisId} />}
            </WithQueryParam>
          }
        />
        <Route
          path="/interes"
          element={
            <WithQueryParam>
              {({ hibisId, scAnswer }) => (
                <Interests hibisId={hibisId} scAnswer={scAnswer} />
              )}
            </WithQueryParam>
          }
        />
        <Route
          path="/kredit/nezakljucen-izracun"
          element={
            <WithQueryParam>
              {({ hibisId }) => <UnfinishedLoanEstimate hibisId={hibisId} />}
            </WithQueryParam>
          }
        />

        <Route
          path="/kredit/interes"
          element={
            <WithQueryParam>
              {({ hibisId }) => <LoanInterest hibisId={hibisId} />}
            </WithQueryParam>
          }
        />

        <Route
          path="/kredit/limit-mastercard"
          element={
            <WithQueryParam>
              {({ hibisId }) => <CreditLimitMastercard hibisId={hibisId} />}
            </WithQueryParam>
          }
        />

        <Route
          path="/kredit/pred-iztekom"
          element={
            <WithQueryParam>
              {({ hibisId }) => <LoanExpiring hibisId={hibisId} />}
            </WithQueryParam>
          }
        />

        <Route
          path="/kredit/pocitnice"
          element={
            <WithQueryParam>
              {({ hibisId }) => <HolidayLoan hibisId={hibisId} />}
            </WithQueryParam>
          }
        />

        <Route
          path="/kredit/zdruzi-obveznosti"
          element={
            <WithQueryParam>
              {({ hibisId }) => <MergeObligation hibisId={hibisId} />}
            </WithQueryParam>
          }
        />

        <Route
          path="/kredit/osvezitev-doma"
          element={
            <WithQueryParam>
              {({ hibisId }) => <HomeRenovationLoan hibisId={hibisId} />}
            </WithQueryParam>
          }
        />

        <Route
          path="/kredit/avto"
          element={
            <WithQueryParam>
              {({ hibisId }) => <CarLoan hibisId={hibisId} />}
            </WithQueryParam>
          }
        />

        <Route
          path="/kredit/tehnologija"
          element={
            <WithQueryParam>
              {({ hibisId }) => <TechLoan hibisId={hibisId} />}
            </WithQueryParam>
          }
        />

        <Route
          path="/kredit/zdravje"
          element={
            <WithQueryParam>
              {({ hibisId }) => <HealthLoan hibisId={hibisId} />}
            </WithQueryParam>
          }
        />

        {/* Newsletters */}
        <Route path="/hvala/pomlad-2025" element={<ThankYouPomlad2025 />} />
        <Route
          path="/hvala/poletje-2025"
          element={
            <WithQueryParam>
              {({ hibisId, scAnswer }) => <ThankYouPoletje2025 hibisId={hibisId} scAnswer={scAnswer} />}
            </WithQueryParam>
          }
        />
        <Route
          path="/hvala/poletni-nakupi-2025"
          element={
            <WithQueryParam>
              {({ hibisId, scAnswer }) => <ThankYouPoletniNakupi2025 hibisId={hibisId} scAnswer={scAnswer} />}
            </WithQueryParam>
          }
        />
        <Route
          path="/seznam-zelja-2026"
          element={
            <WithQueryParam>
              {({ hibisId, scAnswer }) => <WishFor2026 hibisId={hibisId} scAnswer={scAnswer} />}
            </WithQueryParam>
          }
        />


        {/* Service Monitor */}
        <Route path="/service-monitor" element={<div>This webapp is OK!</div>} />        

        {/* Catch-all Redirect */}
        <Route path="*" element={<ExternalRedirect to="https://www.addiko.si" />} />

      </Routes>
    </Router>
  );
}

export default App;